type PropsType = {
  progress: number
}
const ImageUploadProgress = (props: PropsType) => {
  const { progress } = props;
  return (
    <div className="fixed inset-0 z-99 flex bg-[rgba(0,0,0,.3)] fade-in-300">
      <div className="w-360px h-80px px-24px m-auto rounded-12px bg-[#fff]">
        <p className="mx-auto text-center mt-18px mb-14px leading-22px text-16px font-600">图片上传中</p>
        <div className="h-6px w-full rounded-100px bg-[#f2f2f2]">
          <div className="h-full rounded-100px transition-[width] duration-300"
            style={{
              background: 'linear-gradient(90deg, #7774FF 2.49%, #017FFD 53.28%, #01B1FD 98.48%)',
              width: progress + '%'
            }}
          ></div>
        </div>
      </div>
    </div>
  )
}

export default ImageUploadProgress;